var css = {"container":"TextInput-module_container__CBxQs","rightElement":"TextInput-module_rightElement__GZRrg","inputLabel":"TextInput-module_inputLabel__m83AD","lifted":"TextInput-module_lifted__tuHLI","focused":"TextInput-module_focused__lPeuY","filledBackground":"TextInput-module_filledBackground__UYMwn"};

export { css as default };
